



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import {  TechClassChildSetup, TechClassSetup } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { Utils } from '@/helper/utils';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class TechChildSetupClass extends Base {

  public timeList?: any[] = [
  {
  value: 1,
  text: '1:00 AM',
},
{
  value: 2,
  text: '2:00 AM',
}, 
{
  value: 3,
  text: '3:00 AM',
},
{
  value: 4,
  text: '4:00 AM',
},
{
  value: 5,
  text: '5:00 AM',
},
{
  value: 6,
  text: '6:00 AM',
},
{
  value: 7,
  text: '7:00 AM',
}, 
{
  value: 8,
  text: '8:00 AM',
},
{
  value: 9,
  text: '9:00 AM',
},
{
  value: 10,
  text: '10:00 AM',
},
{
  value: 11,
  text: '11:00 AM',
},
{
  value: 12,
  text: '12:00 PM',
}, 
{
  value: 13,
  text: '1:00 PM',
},
{
  value: 14,
  text: '2:00 PM',
},
{
  value: 15,
  text: '3:00 PM',
},
{
  value: 16,
  text: '4:00 PM',
},
{
  value: 17,
  text: '5:00 PM',
}, 
{
  value: 18,
  text: '6:00 PM',
},
{
  value: 19,
  text: '7:00 PM',
},
{
  value: 20,
  text: '8:00 PM',
},
{
  value: 21,
  text: '9:00 PM',
},
{
  value: 22,
  text: '10:00 PM',
},
{
  value: 23,
  text: '11:00 PM',
},
{
  value: 24,
  text: '12:00 AM',
},
  ];

    public techClassSetupFields: Array<VFields<any>>  = [
      {
        key: 'techTime',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: 'Time',
          text: 'text',
          value: 'value',
          items: this.timeList,
          loading: false,
          rules: [
            v => this.required('Time', v)
          ],
          
        },
      }, 
      
      {
        key: 'greenStatusMinHours',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {

          label: "Min Hours For Green Status",
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Min Hours For Green Status', v)
          ]
        },
      },
      {
        key: 'yellowStatusMinHours',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {

          label: "Min Hours For Yellow Status",
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Min Hours For Yellow Status', v)
          ]
        },
      },
      {
        key: 'redStatusMinHours',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: "Min Hours For Red Status",
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Min Hours For Red Status', v)
          ]
        },
      },
      ];


  public techClassChildModel: TechClassChildSetup = {
  id:"",
  techTime: 0,
  greenStatusMinHours: 0,
  yellowStatusMinHours: 0,
  redStatusMinHours:0,
  };

  

  public techClassParentId :string = "";
  public techClassChildId :string = "";
  public storeId: number = 0;
  public form: any = {};
  public requestProgress: boolean = false;
  
  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'TechClassSetup' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.addHourlyTechClassSetupDetails();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    if (this.$route.params.id) {
      this.techClassParentId = this.$route.params.id;
    }

    if (this.$route.params.childId) {
      this.techClassChildId = this.$route.params.childId;
      this.getStoreInfo();
    }
    
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.techClassSetupFields);
      const response = await storeService.getStore(this.storeId);
      const techClassSetupParent = response.storeJson.techClassSetups.find(
        (m) => m.techClassHourlyConfigs.find(
        (h) => h.id ==  this.techClassChildId
        )
      );
      const techClassSetupChild = techClassSetupParent.techClassHourlyConfigs.find(
        (h) => h.id ==  this.techClassChildId
        );


      if(techClassSetupChild){
        this.techClassChildModel.id = techClassSetupChild.id;
        this.techClassChildModel.techTime = techClassSetupChild.hourOfDay;
        this.techClassChildModel.greenStatusMinHours = techClassSetupChild.greenStatusMinHours;
        this.techClassChildModel.yellowStatusMinHours = techClassSetupChild.yellowStatusMinHours;
        this.techClassChildModel.redStatusMinHours = techClassSetupChild.redStatusMinHours;
      }
     
    } finally {
      this.formlyHideSkeleton(this.techClassSetupFields);
    }
  }


  public validateTrunkDetails(): Vue & { validate: () => boolean } {
    return this.$refs.TechClassSetupForm as Vue & { validate: () => boolean };
  }

  public async addHourlyTechClassSetupDetails(): Promise<void> {
    if(this.validateTrunkDetails().validate()){
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.techClassChildId === '') {
          await storeService.addHourlyTechClassSetupDetails(this.storeId,this.techClassParentId,this.techClassChildModel.techTime,this.techClassChildModel.greenStatusMinHours,this.techClassChildModel.yellowStatusMinHours,this.techClassChildModel.redStatusMinHours);
          this.showAlert(true, 'Hour config added successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params:{
                tab:'TechClassSetup'
              }
            })
            .catch((ex) => {
              console.log(ex);
            });
        } else {

          await storeService.updateHourlyTechClassSetupDetails(this.storeId,this.techClassChildId,this.techClassChildModel.techTime,this.techClassChildModel.greenStatusMinHours,this.techClassChildModel.yellowStatusMinHours,this.techClassChildModel.redStatusMinHours);
          this.showAlert(true, 'Hour config updated successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params:{
                tab:'TechClassSetup'
              }
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
}
